export default __webpack_public_path__ + "static/media/Fawn.2210636a.jpg";